export default "__VITE_ASSET__DwxsbtXk__"